import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CtaSectionComponent } from "../cta-section/cta-section.component";

@Component({
  selector: 'app-check-calculator',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, CtaSectionComponent],
  templateUrl: './check-calculator.component.html',
  styleUrls: ['./check-calculator.component.css']
})
export class CheckCalculatorComponent {
  // Form fields
  importeCheque: number = 0;
  fechaVencimiento: string = '';
  tasaDescuento: number = 30;
  tipoDocumento: string = 'CPD PROPIO';
  minDate: string = new Date().toISOString().split('T')[0];

  // Results
  mostrarResultados: boolean = false;
  importeNeto: number = 0;
  interes: number = 0;
  arancelAlyC: number = 0;
  arancelCajaValores: number = 0;
  impuestos: number = 0;
  tna: number = 0;
  tea: number = 0;
  cft: number = 0;
  dias: number = 0;

  // Accordion
  accordionFisica: boolean = false;
  accordionJuridica: boolean = false;

  // Porcentajes de Gastos y Comisiones
  gastosComisionSGR: number = 0.04;
  gastosComisionAlyC: number = 0.01;
  gastosDerechoMercado: number = 0.0006;

  // Fees / Resultados en Pesos
  comisionSGR: number = 0;
  comisionAlyC: number = 0;
  derechoMercado: number = 0;
  Administrativos: number = 0;
  descuento: number = 0;

  tasaDescuentoAplicadaGastos: number = 0;
  tasaDescuentoAnualizada: number = 0;
  diferenciaTasas: number = 0;
  ahorroImpDebCred: number = 0;
  costoFinalGastos: number = 0;

  calculateDiscount(): void {
    if (!this.importeCheque || !this.fechaVencimiento) {
      return;
    }

    // 1. Tasa de mercado en decimal
    const tasaDecimal = this.tasaDescuento / 100;

    // 2. Cálculo de días
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dueDate = new Date(this.fechaVencimiento + 'T00:00:00');
    const diffTime = dueDate.getTime() - today.getTime();
    this.dias = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (this.dias <= 0) return;
    // 3. Descuento del Cheque
    this.descuento = this.importeCheque * (1 - (1 / (1 + (tasaDecimal / 365) * this.dias)));

    // 4. Comisiones prorrateadas por días
    this.comisionSGR = this.importeCheque * (this.gastosComisionSGR * this.dias / 365);
    this.comisionAlyC = this.importeCheque * (this.gastosComisionAlyC * this.dias / 365);

    // 5. Gastos Fijos
    this.derechoMercado = this.importeCheque * (this.gastosDerechoMercado / 90) * this.dias;

    // 6. Costo Final e Importe Neto
    const costoFinal = this.descuento + this.comisionSGR + this.comisionAlyC +
      this.derechoMercado;
    this.importeNeto = this.importeCheque - costoFinal;

    this.costoFinalGastos = this.comisionSGR + this.comisionAlyC + this.derechoMercado;

    // 7. Tasas convertidas a PORCENTAJE (multiplicadas por 100)
    const tasaAplicadaDecimal = (-this.importeNeto / this.importeCheque) + 1;
    const tasaAnualizadaDecimal = (360 * tasaAplicadaDecimal) / this.dias;

    this.tasaDescuentoAplicadaGastos = tasaAplicadaDecimal * 100; // Da 1.50%
    this.tasaDescuentoAnualizada = tasaAnualizadaDecimal * 100;   // Da 38.57%
    this.diferenciaTasas = (tasaAnualizadaDecimal - tasaDecimal) * 100; // Da 16.57%

    this.tna = this.tasaDescuento;
    this.tea = (Math.pow(1 + (tasaDecimal / 365), 365) - 1) * 100;

    // 8. Ahorro Imp. Débito/Crédito en PESOS
    this.ahorroImpDebCred = this.importeNeto * 0.012;

    this.mostrarResultados = true;
  }

  toggleAccordion(type: 'fisica' | 'juridica'): void {
    if (type === 'fisica') {
      this.accordionFisica = !this.accordionFisica;
    } else {
      this.accordionJuridica = !this.accordionJuridica;
    }
  }

  formatCurrency(value: number): string {
    return '$' + value.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  formatPercent(value: number): string {
    return value.toFixed(2) + '%';
  }

  preventDecimal(event: KeyboardEvent) {
    if (event.key === '.' || event.key === ',') {
      event.preventDefault();
    }
  }

  preventInvalidChars(event: KeyboardEvent): void {
    if (['.', ',', '-', 'e', 'E', '+'].includes(event.key)) {
      event.preventDefault();
    }
  }
}